/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:c4d9e531-b3af-4cb0-acb2-4668bd609656",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_PbsW1Jhsc",
    "aws_user_pools_web_client_id": "6ev25nhqdbv5rq6rkku93pgb65",
    "oauth": {
        "domain": "minesight-stage.auth.us-east-2.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "minesightborer489fc8a0deb24b949d89a80e93dc9b62133602-stage",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
